import classNames from 'classnames';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import styles from './OrderTimer.module.scss';
import { iRootDispatch, iRootState } from '../../../../store/store';
import { Button } from 'devextreme-react/button';
import { humanizeDuration } from 'fulogics-ui-core/dist/utils/duration';
import { dateDiff } from 'fulogics-ui-core/dist/utils/dates';

const mapStateToProps = (state: iRootState) => ({} as OrderTimerDisplayOptions);

const mapDispatch = (_dispatch: iRootDispatch, _ownDispatch: OrderTimerDisplayOptions) =>
    ({
        //
        ..._ownDispatch,
    } as OrderTimerDisplayOptions);

const humanize = (date?: Date) => (date ? humanizeDuration(dateDiff(date, new Date())) : undefined);

const OrderTimer = connect(
    mapStateToProps,
    mapDispatch as any
)((props: OrderTimerProps) => {
    const { t } = useTranslation('OrderTimer');
    const [deadlineDurationHumanize, setDeadlineDurationHumanize] = useState<string | undefined>(
        humanize(props.data?.draftCloseDeadline)
    );
    const [deadlineDurationMinutes, setDeadlineDurationMinutes] = useState(
        dateDiff(props.data?.draftCloseDeadline, new Date(), 'minutes')
    );
    //
    useEffect(() => {
        const timer = setInterval(() => {
            setDeadlineDurationHumanize(humanize(props.data?.draftCloseDeadline));
            setDeadlineDurationMinutes(
                dateDiff(props.data?.draftCloseDeadline, new Date(), 'minutes')
            );
        }, 60 * 1000);
        return () => {
            clearInterval(timer);
        };
    }, []);
    //
    return (
        <div
            className={classNames(
                styles.container,
                {
                    [styles.containerWarning]:
                        deadlineDurationMinutes && deadlineDurationMinutes < 30,
                },
                {
                    [styles.containerError]:
                        deadlineDurationMinutes <= 0,
                },
                props.className
            )}
        >
            <div className={classNames(styles.timerContainer)}>
                {deadlineDurationMinutes && deadlineDurationMinutes > 0 ? (
                    <>
                        <label>{t('realizationAt')}</label>
                        <label>{deadlineDurationHumanize}</label>
                    </>
                ) : (
                    <label>{t('saveOrderASAP')}</label>
                )}
            </div>
            {/*<Button
                className={classNames(styles.changeButton)}
                text={t('changeDateButton')}
                type="normal"
                stylingMode="text"
            />*/}
        </div>
    );
});

export default OrderTimer;

export type OrderTimerProps = { data?: OrderTimerData } & OrderTimerDisplayOptions;

export type OrderTimerData = {
    /* Piotr Pierzgalski: CurrentEditing to to osoba, która aktualnie ma locka na orderze. EditingDeadline to moment, kiedy lock wygaśnie (aktualnie to jest minuta od jego założenia bądź ostatniego odświeżenia, przy czym też aktualnie nawet jak wygaśnie to nie będzie żadnych konsekwencji tego faktu).
        Natomiast DraftCloseDeadline to moment, który - kiedy nadejdzie - to spowoduje samoistne zamknięcie i wysłanie się orderu (zakładając, że order będzie w stanie, który na to pozwala).
       Michał August: ok, a odpowiedź na na drugie pytanie
       Piotr Pierzgalski: Hmm. Docelowo kiedyś pewnie oba. :stuck_out_tongue: Ale aktualnie mieliśmy locki olać, więc w sumie tylko DraftCloseDeadline nas chyba obchodzi - czyli to wyświetl. Wartoby to opisać jakąś labelką mówiącą o tym, że to jest moment, kiedy się to zamówienie samoistnie wyśle, żeby user wiedział o co chodzi. x)*/

    /*currentEditing?: {
        editingDeadline?: Date;
    };*/
    draftCloseDeadline?: Date;
};

export interface OrderTimerDisplayOptions {
    className?: string;
    //
    onChangeOrderDate?: () => Promise<void>;
}
